import React from "react";
import styles from "./RoundedImage.module.css";

export const RoundedImage = ({ children }: React.PropsWithChildren<{}>) => {
  return <div className={styles.roundedimage}>{children}</div>;
};
